module.exports = __webpack_public_path__ + "img/facebook.53b4fafa.svg";